<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Laudos de Higienização</app-titulo>
      <div class="header-buttons"></div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem</div>
        <div class="align-button">
          <form [formGroup]="form">
            <div class="table-filters">
              <app-input
                label="Placa do Cavalo"
                placeholder="Digite"
                name="TX_PLCA_CRRT"
                formControlName="TX_PLCA_CRRT"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data Início"
                placeholder="Digite aqui"
                name="DT_GATE_ENTR_INIC"
                formControlName="DT_GATE_ENTR_INIC"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data Fim"
                placeholder="Digite aqui"
                name="DT_GATE_ENTR_FIM"
                formControlName="DT_GATE_ENTR_FIM"
                width="100%"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite"
        name="TX_PLCA_CRRT"
        formControlName="TX_PLCA_CRRT"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_INIC"
        formControlName="DT_GATE_ENTR_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Fim"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_FIM"
        formControlName="DT_GATE_ENTR_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
